import React from "react";
import { arrayOf, shape, string, object, number, bool } from "prop-types";

import PromoResultCard from "./PromoResultCard.jsx";

const propTypes = {
  results: arrayOf(
    shape({
      key: string,
      title: string,
      imageSrc: string,
      contentUrl: string,
      date: string,
      body: string,
    }),
  ),
  focusRef: object,
  focusItem: number,
  dictionary: object,
  showCta: bool,
};

/**
 * Renders Promo Listing results using the exact existing Multi Promo layout/markup
 * (.multi-promo / .multi-promo__items / .multi-promo__promo) so the grid of cards is
 * visually identical to the existing Multi Promo component. Cards themselves are
 * PromoResultCard (same .promo markup + date).
 */
const PromoResultsGrid = (props) => {
  const { results, focusRef, focusItem, dictionary, showCta } = props;

  if (!results || results.length < 1) {
    return null;
  }

  const ctaLabel = dictionary?.ctaLabel || "Learn More";

  return (
    <div className="component multi-promo multi-promo--dynamic promo-listing__grid">
      <section className="multi-promo__items">
        {results.map((result, i) => (
          <div
            className="multi-promo__promo"
            key={result.key || `PROMO-RESULT-${i}`}
          >
            <PromoResultCard
              title={result.title}
              srcset={result.imageSrc}
              sizes="(min-width: 1024px) 280px, (min-width: 576px) 50vw, 100vw"
              date={result.date}
              description={result.body}
              url={result.contentUrl}
              cta={ctaLabel}
              showCta={showCta}
              focusRef={i === focusItem ? focusRef : null}
            />
          </div>
        ))}
      </section>
    </div>
  );
};

PromoResultsGrid.propTypes = propTypes;
export default PromoResultsGrid;
